<ng-container>
    <div
        class="hero-banner-slides-container"
        [style]="`--bg: ${getBackground()}`"
        [ngClass]="{
            'hero-banner-slides-container--text-color-white': block.data.textColor === 'white',
            'hero-banner-slides-container--text-color-black': block.data.textColor === 'black',
        }">
        <div
            class="position-relative hero-banner-slides"
            [ngStyle]="{
                '--image-height--mobile': block.data.imgHeightMobile,
                '--image-height--tablet': block.data.imgHeightTablet,
                '--image-height--desktop': block.data.imgHeightDesktop,
            }">
            <swiper #homeBannerSwiper [config]="swiperConfig">
                @for (item of block.content; track item.id) {
                    <div class="hero-banner-slide" swiperSlide (focusin)="onFocusIn()" (focusout)="onFocusOut()">
                        <div class="hero-banner-slide__content">
                            @if (item.data.heading) {
                                <h1 class="hero-banner-slide__heading">
                                    {{ item.data.heading }}
                                </h1>
                            }

                            @if (item.data.subheading) {
                                <div class="hero-banner-slide__subheading" [innerHTML]="item.data.subheading"></div>
                            }

                            @if (item.data.content) {
                                <div class="hero-banner-slide__description" [innerHTML]="item.data.content"></div>
                            }

                            @if (item.data.link) {
                                @if (isExternalLink(item)) {
                                    <a
                                        [attr.aria-label]="item.data.linkAriaLabel"
                                        [attr.target]="item.data.externalLink ? '_blank' : '_self'"
                                        [attr.rel]="item.data.externalLink ? 'noopener noreferrer' : null"
                                        [innerHTML]="item.data.linkText"
                                        [href]="item.data.link"
                                        class="btn btn-primary hero-banner-slide__cta"></a>
                                } @else {
                                    <a
                                        [attr.aria-label]="item.data.linkAriaLabel"
                                        [attr.target]="item.data.externalLink ? '_blank' : '_self'"
                                        [attr.rel]="item.data.externalLink ? 'noopener noreferrer' : null"
                                        [innerHTML]="item.data.linkText"
                                        [routerLink]="getRouterLink(item.data.link)"
                                        class="btn btn-primary hero-banner-slide__cta"></a>
                                }
                            }
                        </div>

                        @if (item.data.image) {
                            <img
                                [ngStyle]="{
                                    '--image-position--mobile': item.data.imgPositionMobile,
                                    '--image-position--tablet': item.data.imgPositionTablet,
                                    '--image-position--small-desktop': item.data.imgPositionSmallDesktop,
                                    '--image-position--large-desktop': item.data.imgPositionLargeDesktop,

                                    '--image-scale--mobile': item.data.imgScaleMobile,
                                    '--image-scale--tablet': item.data.imgScaleTablet,
                                    '--image-scale--small-desktop': item.data.imgScaleSmallDesktop,
                                    '--image-scale--large-desktop': item.data.imgScaleLargeDesktop,
                                }"
                                class="hero-banner-slide__image"
                                [src]="item.data.image"
                                alt="" />
                        }
                    </div>
                }
            </swiper>
            <div class="swiper-control-wrapper">
                <button aria-label="Previous slide" class="swiper-button-prev" (click)="moveSlidesPrev()"></button>
                <div class="swiper-pagination-bullets"></div>
                <button aria-label="Next slide" class="swiper-button-next" (click)="moveSlidesNext()"></button>
                <button
                    [attr.aria-label]="isPaused() ? 'Play slide' : 'Pause slide'"
                    class="swiper-button-play-pause"
                    [ngClass]="{
                        'swiper-button-play-pause--paused': isPaused(),
                        'swiper-button-play-pause--playing': !isPaused(),
                    }"
                    (click)="toggleAutoplay()"></button>
            </div>
        </div>
    </div>
</ng-container>
